




























































































































































import {Vue, Component, Prop, Emit} from 'nuxt-property-decorator'
import {EditorMenuBar} from 'tiptap'

import {FormInput} from '../FormInput'
import {Dropdown, DropdownItem} from '../Dropdown'

@Component({
  components: {EditorMenuBar, Dropdown, DropdownItem, FormInput},
})
class HtmlEditorMenu extends Vue {
  @Prop({type: Object, required: true})
  editor: any

  @Prop({type: Boolean, default: false})
  viewSource: boolean

  @Prop({type: Boolean, default: () => false})
  enableCharts: boolean

  link = {
    url: '',
    text: '',
  }
  images = []

  tweetUrl: string = ''

  @Emit()
  fileSelection(event) {
    const {files = []} = event.target
    this.images = []
    return files
  }

  addLink(command) {
    const urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    let {url, text} = this.link

    if (urlRegex.test(url)) {
      if (!/^https?:\/\//i.test(url)) {
        url = 'http://' + url
      }
      command({href: url, text: text || 'Link'})
      this.link.url = ''
      this.link.text = ''
    }
  }

  addTweet(command) {
    command({url: this.tweetUrl})
  }

  onUrlDropdownShow() {
    const {selection} = this.editor.state
    const {empty, $from, $to} = selection
    const content = selection.content().content

    if (!empty && $from.sameParent($to) && $from.parent.inlineContent) {
      const contentNode = content.content[0]
      const text = contentNode.textContent
      if (text.length) {
        this.link.text = text
      }
    }
  }
}

export default HtmlEditorMenu
